<script>
  import { createEventDispatcher } from "svelte";
  import axios from "axios";
  import config from "../../stores/config";
  import * as ls from "local-storage";
  import t from "../../utils/t";

  export let _id;
  export let addedOn;
  export let fullname;
  export let username;
  export let tel;
  export let email;
  export let department;

  const dispatch = createEventDispatcher();

  const handleDelete = () => {
    let confirmDelete = confirm(
      `❌ ${t({
        en: "Do you wish to delete",
        fr: "Voulez-vous supprimer",
      })} ${fullname}?`
    );

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/users/${_id}`, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(
            t({
              en: "Only the super admin has the clearance to perform this task",
              fr: "Seules les super admins ont la permission d'executer cette action",
            })
          );
        });
    }
  };
</script>

<div class="tr tracking-wider border-b border-gray-100 ">
  <div style="min-width: 10rem; max-width: 10rem;" class="flex items-center">
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
  </div>
  <div style="min-width: 10rem; max-width: 10rem;">
    {new Date(addedOn).toDateString() || "N/A"}
  </div>
  <div style="min-width: 20rem; max-width: 20rem;">{fullname}</div>
  <div style="min-width: 15rem; max-width: 15rem;">{username}</div>
  <div style="min-width: 10rem; max-width: 10rem;">{tel}</div>
  <div style="min-width: 15rem; max-width: 15rem;">{email}</div>
  <div style="min-width: 15rem; max-width: 15rem;">{department}</div>
</div>

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
